"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = exports.default = {
  LOGGED_OUT: 'LOGGED_OUT',
  AUTHENTICATED: 'AUTHENTICATED',
  LOGGING_IN: 'LOGGING_IN',
  LOGGED_IN: 'LOGGED_IN',
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  PASSWORD_RESET_REQUIRED: 'PASSWORD_RESET_REQUIRED',
  MFA_REQUIRED: 'MFA_REQUIRED',
  EMAIL_VERIFICATION_REQUIRED: 'EMAIL_VERIFICATION_REQUIRED',
  CONFIRMATION_REQUIRED: 'CONFIRMATION_REQUIRED'
};
module.exports = exports.default;